import {
    tss,
} from 'app/tss'

const general = 'general'
const fees = 'fees'
const truckingCapacity = 'truckingCapacity'
const feeDays = 'feeDays'

export default tss.create(({
    theme,
}) => {
    const gridTemplateAreas = `
            "${general} ${general}"
            "${truckingCapacity} ${feeDays}"
            "${fees} ${fees} "`

    return {
        root: {
            backgroundColor: theme.palette.secondary[50],
            cursor: 'default',
        },
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(1),
            gridTemplateAreas,
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        general: {
            gridArea: general,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        truckingCapacity: {
            gridArea: truckingCapacity,
        },
        fees: {
            gridArea: fees,
            gridTemplateColumns: '1fr !important',
        },
        minOrder: {
            marginBottom: theme.spacing(1),
        },
        rejectedReasonHint: {
            '& span': {
                fontSize: theme.typography.subtitle2.fontSize,
                color: theme.palette.secondary[700],
            },
        },
        feeDays: {
            gridArea: feeDays,
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
    }
})
